import * as actionsType from "./types";

// Product Actions

export const getProducts = () => {
    console.log("Get Prodcuts")

  return  {type: actionsType.GET_PRODUCTS
}}

export const setProducts = (list) => ({
    type: actionsType.SET_PRODUCTS,
    payload: { list }
})

export const getProductDetails = () => ({
    type: actionsType.GET_PRODUCT_DETAILS
})

export const setProductDetails = (details) => ({
    type: actionsType.SET_PRODUCT_DETAILS,
    payload: {  details  }
})


// User Actions Login , Logout etc

export const login = (val) => ({
    type: actionsType.LOGIN,
    payload: val,

})

export const login_success = (user) => ({
    type: actionsType.LOGIN_SUCCESS,
    payload:   user  ,
})

export const logout = () => ({
    type: actionsType.LOGOUT
})

export const logout_success = (user) => ({
    type: actionsType.LOGOUT_SUCCESS,
    payload: {  user  }
})

export const register = (details) => ({
    type: actionsType.REGISTER,
    payload: details
})

export const register_proceed = (details) => ({
    type: actionsType.REGISTER_PROCEED,
    payload: details
})

export const forgot_password = (details) => ({
    type: actionsType.FORGOT_PASSWORD,
    payload: details
})

export const forgot_password_requested = (details) => ({
    type: actionsType.FORGOT_PASSWORD_REQUESTED,
    payload: details
})
export const forgot_password_success = (details) => ({
    type: actionsType.FORGOT_PASSWORD_SUCCESS,
    payload: details
})
export const forgot_password_failure = (details) => ({
    type: actionsType.FORGOT_PASSWORD_FAILURE,
    payload: details
})


export const updateProfile =(details)=>({
    type: actionsType.UPDATE_PROFILE,
    payload: details
})

export const changePassword =(details)=>({
    type: actionsType.CHANGE_PASSWORD,
    payload: details
})



// Loaders Actions  

export const show_loader = () => ({
    type: actionsType.SHOW_LOADER,
})

export const hide_loader = () => ({
    type: actionsType.HIDE_LOADER,
})
